'use strict';


module.exports = function (client) {

    client.disco.addFeature('urn:xmpp:message-correct:0');

    client.on('message', function (msg) {
        if (msg.replace) {
            client.emit('replace', msg);
            client.emit('replace:' + msg.id, msg);
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/stanza.io/lib/plugins/correction.js
// module id = 309
// module chunks = 0